import { useSyncExternalStore } from "react";

import { SCREENS } from "@/lib/screens";

// md(641px) 미만이면 폰 — 서버·첫 그림에서는 모르므로(null) 두 뷰를 다 그리고 CSS(md:hidden · hidden md:contents)가 가른다.
const QUERY = `(min-width: ${SCREENS.md.min})`;

const subscribe = (onChange: () => void) => {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
};

const getSnapshot = (): boolean => !window.matchMedia(QUERY).matches;

const getServerSnapshot = (): boolean | null => null;

export const usePhone = (): boolean | null => useSyncExternalStore<boolean | null>(subscribe, getSnapshot, getServerSnapshot);
